<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  max-width: 120rem;
  margin: auto;
  background-color: #f5f5f5;
  width: 100%;
  min-height: 100%;
  margin-bottom: 5rem;
}
html{
  width: 100%;
  height: 100%;
}
body{
  width: 100%;
  height: 100%;
}
img{
  max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue